module.exports = __webpack_public_path__ + "img/NP.a377eec5.svg";